import { createFileRoute } from '@tanstack/react-router';
import { useForm } from 'react-hook-form';

import { PageTitle } from '@components/PageTitle';
import { Form } from '@components/form';
import { InputControlled } from '@components/input/controlled';
import { removeUnderscoreFormatter } from '@formatters/removeUnderscore.formatter';
import type { User } from '@models/user.model';

export const Route = createFileRoute('/_layout/(private)/profile')({
  component: Profile,
});

function Profile() {
  const {
    auth: { user },
  } = Route.useRouteContext();

  const form = useForm<User>({
    defaultValues: {
      name: user?.name,
      email: user?.email,
      phone: user?.phone,
      document: user?.document,
      crm: user?.crm,
    },
  });

  return (
    <div className="w-full space-y-3">
      <PageTitle title="Meu perfil" />

      <Form.Provider {...form}>
        {/* <form onSubmit={handleOnSubmit}> */}
        <div className="grid gap-2 md:grid-cols-2">
          <InputControlled disabled label="Nome completo" name="name" />
          <InputControlled disabled label="Email" name="email" type="email" />
        </div>
        <div className="mb-6 grid gap-2 sm:grid-cols-2 md:grid-cols-3">
          <InputControlled
            disabled
            format="(##) #####-####"
            label="Telefone"
            mask="_"
            name="phone"
            placeholder="Telefone"
            variant="withPattern"
          />
          <InputControlled
            disabled
            format="###.###.###-##"
            label="CPF"
            mask="_"
            name="document"
            variant="withPattern"
          />

          <InputControlled
            disabled
            format="#######"
            label="CRM"
            name="crm"
            variant="withPattern"
          />
        </div>

        <h6 className="text-secondary leading-none">
          Especializações cadastradas
        </h6>
        {user && user.medicalSpecialties.length > 0 ? (
          <div className="grid gap-y-2 lg:grid-cols-2">
            {user.medicalSpecialties.map(specialty => (
              <div
                className="border-input flex h-10 items-center gap-x-2 rounded-lg border bg-white px-4"
                key={specialty.id}>
                <span className="flex flex-1 text-sm text-gray-600">
                  {specialty.name}
                </span>
                <span className="text-tertiary text-sm font-medium capitalize">
                  {removeUnderscoreFormatter(specialty.status, {
                    lowercase: true,
                  })}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <span className="text-gray-500">
            Nenhuma especialização cadastrada
          </span>
        )}
      </Form.Provider>
    </div>
  );
}
